// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var SubusersPageAccountsListItem = require("./SubusersPageAccountsListItem.bs.js");
var SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");

var getConnectionNodes = SubusersPageAccountsList_account_graphql.Utils.getConnectionNodes;

var convertFragment = SubusersPageAccountsList_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, SubusersPageAccountsList_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsList_account_graphql.node, convertFragment, fRef);
}

var AccountFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SubusersPageAccountsList(props) {
  var currentUserRole = props.currentUserRole;
  var account = use(props.account);
  var members = getConnectionNodes(account.members);
  return JsxRuntime.jsx("div", {
              children: members.map(function (member, index) {
                    return JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(SubusersPageAccountsListItem.make, {
                                      member: member.fragmentRefs,
                                      account: account.fragmentRefs,
                                      currentUserRole: currentUserRole
                                    })
                              }, index.toString());
                  })
            });
}

var make = SubusersPageAccountsList;

exports.AccountFragment = AccountFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
